var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"advCartMainContainer"}},[_c('adv-cart-product-list',{attrs:{"mini-cart":_vm.miniCart,"read-only":_vm.readOnly,"disable-product-links":_vm.disableProductLinks}}),_vm._v(" "),_c('adv-cart-gift-list',{attrs:{"mini-cart":_vm.miniCart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }